<script>
	import PullToRefresh from 'pulltorefreshjs';
	export let data = {};

	const ptr = PullToRefresh.init({
	mainElement: 'body',
	onRefresh() {
			refresh_data();
	}
	});

	async function getData() {
        const response = await fetch(`http://192.168.2.30:8083/produzione`);
        //const response = await fetch(`http://localhost:8000/produzione`);
        if (!response) {
            return false;
		}
		const _data = await response.json();
		if (response.ok) {
			return _data;
		} else {
			throw new Error(_data);
		}
	}
	function refresh_data() {
		data = getData();
	}
	refresh_data();
</script>

<main>
    <h1>Impianto solare argine74</h1>
	
	<img alt="Solar Energy" src="img/energy.png" on:click="{refresh_data}">

{#await data}
	<p>...waiting</p>

{:then data}

  <div class="solardata">
    <ul>
      <li class="prodotta">Prodotta: { data.produced_power } KW</li>
      <li class="consumata">Consumata: { data.consumed_power } KW</li>
    </ul>
  </div>

	<br>

{:catch error}
	<p class="error">{error.message}</p>
{/await}
</main>

<style>
	main {
		font-family: Avenir, Helvetica, Arial, sans-serif;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		text-align: center;
		color: #2c3e50;
		margin-top: 60px;
	}

	ul {
		list-style-type:none;
		padding:0;
		font-size:1.75em;
		font-weight:700
	}
	li {
		margin:0 10px
	}
	.prodotta { color:green }
	.consumata { color:red }
	.error { color:red }
</style>